<template>
  <div>
  <blockquote>
	  <p><strong> Thank you</strong> {{ authUser.name }} for registering with us.</p>
  </blockquote>
  <blockquote>
        <p>A verification code has been sent to your email <strong>{{ authUser.email }}.</strong>.<br />
        If you have not received an email, please click below to resend.<br />
        Please ensure the email provided is spelt correctly.</p>
   </blockquote>

    <form @submit.prevent="sendVerification">
    
      <BaseBtn type="submit" text="Send verification link" />
    </form>
    <FlashMessage :message="message" :error="error" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getError } from "../utils/helpers";
import BaseBtn from "./BaseBtn";
import AuthService from "../services/AuthService";
import FlashMessage from "./FlashMessage";

export default {
  name: "UpdatePassword",
  components: {
    BaseBtn,
    FlashMessage,
  },
  data() {
    return {
      error: null,
      message: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["authUser"]),
  },
  methods: {
    sendVerification() {
      this.error = null;
      this.message = null;
      const payload = {
        user: this.authUser.id,
      };
      AuthService.sendVerification(payload)
        .then(() => (this.message = "Verification email sent."))
        .catch((error) => (this.error = getError(error)));
    },
  },
};
</script>
